import React from "react";
import { Check, X } from "lucide-react";
import { getMonthlyAttendanceRate } from "./attendanceViewDataUtils";
import {
  ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_BODY_CLASS,
  ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_CLASS,
  ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_HEAD_CLASS,
  ATTENDANCE_VIEW_MONTHLY_MOBILE_DAY_ITEM_CLASS,
  ATTENDANCE_VIEW_MONTHLY_MOBILE_LIST_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_HEAD_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_NAME_CELL_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_RATE_CELL_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_ROW_CLASS,
  ATTENDANCE_VIEW_MONTHLY_TABLE_STATUS_CELL_CLASS,
  getAttendanceViewMonthlySmallStatusIconClass,
  getAttendanceViewMonthlyTableStatusIconClass,
  getAttendanceViewRateBadgeClass,
} from "./attendanceViewStyles";

export default function AttendanceMonthlyView({
  brand,
  filteredStudents,
  handleJumpToDaily,
  isMobile,
  monthlyData,
  sundaysInMonth,
}) {
  if (isMobile) {
    return (
      <div className={ATTENDANCE_VIEW_MONTHLY_MOBILE_LIST_CLASS}>
        {filteredStudents.map((student) => {
          const rate = getMonthlyAttendanceRate(student.id, sundaysInMonth, monthlyData);

          return (
            <div key={student.id} className={ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_CLASS}>
              <div className={ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_HEAD_CLASS}>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center border border-gray-100 overflow-hidden">
                    {student.photoUrl ? <img src={student.photoUrl} alt="" className="w-full h-full object-cover" /> : <img src={student.gender === "남" ? "/images/boy_3d_light.png" : student.gender === "여" ? "/images/girl_3d_light.png" : "/images/boy_3d_light.png"} alt="avatar" className="w-full h-full object-cover transform scale-110" />}
                  </div>
                  <div>
                    <div className="font-black text-gray-800 text-base">{student.name}</div>
                    <div className="text-[11px] text-gray-400 font-bold">{student.grade} {student.class}</div>
                  </div>
                </div>
                <span className={getAttendanceViewRateBadgeClass(rate)}>{rate}%</span>
              </div>

              <div className={ATTENDANCE_VIEW_MONTHLY_MOBILE_CARD_BODY_CLASS}>
                {sundaysInMonth.map((date) => {
                  const status = monthlyData[date]?.[student.id];
                  return (
                    <div key={date} className={ATTENDANCE_VIEW_MONTHLY_MOBILE_DAY_ITEM_CLASS} onClick={() => handleJumpToDaily(date)}>
                      <span className="text-[10px] font-bold text-gray-400">{date.slice(8, 10)}일</span>
                      {status === "present" ? (
                        <div className={getAttendanceViewMonthlySmallStatusIconClass(status)}><Check size={12} strokeWidth={4} /></div>
                      ) : status === "late" ? (
                        <div className={getAttendanceViewMonthlySmallStatusIconClass(status)}><div className="w-2 h-2 rounded-full bg-amber-500"></div></div>
                      ) : status === "absent" ? (
                        <div className={getAttendanceViewMonthlySmallStatusIconClass(status)}><X size={12} strokeWidth={4} /></div>
                      ) : (
                        <div className={getAttendanceViewMonthlySmallStatusIconClass(status)}></div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <table className={ATTENDANCE_VIEW_MONTHLY_TABLE_CLASS}>
      <thead className={ATTENDANCE_VIEW_MONTHLY_TABLE_HEAD_CLASS}>
        <tr>
          <th className="p-4 pl-6 sticky left-0 bg-white/95 backdrop-blur-xl z-30 min-w-[120px] rounded-l-[1.5rem] text-sm text-gray-400 font-bold border-b border-gray-100 shadow-[4px_0_10px_-5px_rgba(0,0,0,0.05)]">
            학생명
          </th>
          {sundaysInMonth.map((date) => (
            <th key={date} onClick={() => handleJumpToDaily(date)} className={`p-2 text-center min-w-[60px] cursor-pointer ${brand.primaryLightHoverBgClass} transition-colors group border-b border-gray-100 bg-white/90 backdrop-blur-md`}>
              <div className="flex flex-col items-center gap-1 group-hover:-translate-y-0.5 transition-transform duration-200">
                <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wide">{date.slice(5, 7)}월</div>
                <div className={`text-lg font-black text-gray-800 ${brand.primaryHoverTextClass} bg-gray-50 rounded-lg px-2 py-0.5`}>{date.slice(8, 10)}</div>
              </div>
            </th>
          ))}
          <th className="p-4 text-center min-w-[80px] rounded-r-[1.5rem] text-sm text-gray-400 font-bold border-b border-gray-100 bg-white/95 backdrop-blur-xl">출석률</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-50">
        {filteredStudents.map((student) => {
          const rate = getMonthlyAttendanceRate(student.id, sundaysInMonth, monthlyData);
          return (
            <tr key={student.id} className={ATTENDANCE_VIEW_MONTHLY_TABLE_ROW_CLASS}>
              <td className={ATTENDANCE_VIEW_MONTHLY_TABLE_NAME_CELL_CLASS}>
                <div className="flex items-center gap-3">
                  <div className="relative">
                    {student.photoUrl ? (
                      <img src={student.photoUrl} alt="" className="w-9 h-9 rounded-full object-cover border border-white shadow-sm" />
                    ) : (
                      <div className="w-9 h-9 rounded-full flex items-center justify-center shadow-sm border border-white bg-white overflow-hidden">
                        <img src={student.gender === "남" ? "/images/boy_3d_light.png" : student.gender === "여" ? "/images/girl_3d_light.png" : "/images/boy_3d_light.png"} alt="avatar" className="w-full h-full object-cover transform scale-110" />
                      </div>
                    )}
                  </div>
                  <span className="font-bold text-gray-700 text-sm">{student.name}</span>
                </div>
              </td>
              {sundaysInMonth.map((date) => {
                const status = monthlyData[date]?.[student.id];
                return (
                  <td key={date} className={ATTENDANCE_VIEW_MONTHLY_TABLE_STATUS_CELL_CLASS}>
                    <div className="flex items-center justify-center">
                      {status === "present" ? (
                        <div className={getAttendanceViewMonthlyTableStatusIconClass(status)}><Check size={14} strokeWidth={4} /></div>
                      ) : status === "late" ? (
                        <div className={getAttendanceViewMonthlyTableStatusIconClass(status)}><div className="w-2.5 h-2.5 rounded-full bg-amber-500"></div></div>
                      ) : status === "absent" ? (
                        <div className={getAttendanceViewMonthlyTableStatusIconClass(status)}><X size={14} strokeWidth={4} /></div>
                      ) : (
                        <div className={getAttendanceViewMonthlyTableStatusIconClass(status)}></div>
                      )}
                    </div>
                  </td>
                );
              })}
              <td className={ATTENDANCE_VIEW_MONTHLY_TABLE_RATE_CELL_CLASS}>
                <span className={getAttendanceViewRateBadgeClass(rate)}>{rate}%</span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
